import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SiteWrapper from 'components/SiteWrapper/SiteWrapper';
import HomeImages from '../Home/HomeImages/HomeImages';
import { HeaderRegionName, AssetName, RadionButtons, RadionAndImageWrapper } from '../Home/Home.styled';
import RadioButtonsGroup from '../../../components/RadionButton/RadioButtonsGroup';
import { sortTestEquipment, getTestMakeModelData, searchTestEquipment } from '../TestEquipment/TestEquipment.actions';
import {
  getAllRegionData, saveAssetName, setDataLoaded,
  getTrfMasterLists, getAllInfoDocuments, setCurrentView,
  saveGroupName, checkOfflineDataPresent, setPreviousScreen,
  sendOfflineData,
  fetchAlertNotification,
  getAnnouncementState
} from '../Home/Home.actions';
import { getAllSavedNonMoTRFData } from '../SavedTRFPrintScreen/SavedTRFPrintScreen.actions';
import { MRAT_USER_ROLE, NONMO_USER_ROLE } from '../Home/Home.constants';
import { clearLateEntryDPSData, getMultiTRFDetails, resetFormData, resetTestPointVal, setDataForFormTagSelected, setSelectedTRF } from '../Forms/Forms.actions';
import TrfDropdownSelectNonMo from './TrfDropdownSelectNonMo';
import { clearSRAData } from '../Forms/FormsP8.actions';
import { getSelectTagScreenNonMoData } from './TagSelectionNonMoScreen.action';
import AlertDialog from 'components/AlertDialog/AlertDialog';
import { getAllDPSData } from '../SubSections/DPS/DPS.actions';
import { useMsal } from '@azure/msal-react';

const HomePage = (props) => {
  const {
    dispatch,
    bpRegionNameAlias,
    assetNameList,
    loadAllTagSelectionNonMoData,
    isDataLoaded,
    isMRATOnline,
    isOfflineDataPresent,
    loadAllSavedTRFData,
    loadTestMakeModelData,
    saveAsset,
    selectedAssetName,
    setCurrentAppView,
    setPreviousAppScreen,
    getInfoDocuments,
    checkOfflineFormDataPresent,
    selectedGroupName,
    saveGroup,
    regionDetails,
    selectedAssetAliasName,
    searchStringForTestEq,
    searchTestEquipmentRecords,
    sortColumnTestEquiment,
    setSortedTestEquipmentView,
    sortStatusAscOrder,
    sortDeviceTypeAscOrder,
    userRole,
    clearTestPointValue,
    resetSRAData,
    initialiseDataForFormTagSelected,
    homeDraftData,
    resetFormDataValues,
    settingSelectedTRF,
    alertsNotification,
    toastVisible,
    showNotificationAlert,
    IsLateEntry,
    loadAllDpsData,
    getAnnouncementStateLog
  } = props;

  const { instance } = useMsal();
  const groupNameList = _.uniq(regionDetails.map(x => x.MratGroup));
  const selectedAssetImage = localStorage.getItem(`${selectedAssetName?.toUpperCase()}-image`);

  const showAssetImage = regionDetails.find(x => x.BpSiteName.toUpperCase() === selectedAssetName.toUpperCase())?.ImageStatus !== 'Inactive';
  const selectedTrfId = useSelector(({ Forms }) => Forms.selectedTrfId);
  const [openNotificationAlerts, setOpenNotificationAlerts] = useState([]);
  const [notificationAlertsShown, setNotificationAlertsShown] = useState(() => localStorage.getItem('notificationAlertsShown') === 'true');
  const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
  const testEquipmentButtonHandler = async () => {
    setPreviousAppScreen(IsLateEntry ? 'lateEntryHome' : 'home');
    setCurrentAppView('testequipment');
    await loadTestMakeModelData();
    searchStringForTestEq && searchTestEquipmentRecords(searchStringForTestEq);
    sortColumnTestEquiment !== '' && (sortColumnTestEquiment === 'DeviceType'
      ? setSortedTestEquipmentView(sortColumnTestEquiment, sortDeviceTypeAscOrder)
      : setSortedTestEquipmentView(sortColumnTestEquiment, sortStatusAscOrder));
  };
  const printButtonHandler = async () => {
    setCurrentAppView('savedTRF');
    await loadAllSavedTRFData();
  };
  const actionButtonHandler = () => {
    resetFormDataValues();
    clearTestPointValue();
    resetSRAData();
    setCurrentAppView(selectedTrfId.trim());
    loadAllSavedTRFData();
    setPreviousAppScreen('');
  };

  const modifyButtonHandler = async () => {
    setCurrentAppView('tagselectionnonmoscreen');
  };
  const loadData = () => {
    showNotificationAlert();
    dispatch(getAllRegionData());
    dispatch(getMultiTRFDetails());
    props.getTrfMasterLists();
    getInfoDocuments();
  };

  // when application comes online then reload data
  const onlineOfflineCallback = (e) => {
    if (e.type === 'online') {
      loadData();
    }
  };

  const widerFooter = '4rem';

  useEffect(() => {
    if (bpRegionNameAlias && !isDataLoaded) {
      loadData();
      dispatch(setDataLoaded());
    }
    settingSelectedTRF('');
    dispatch(clearLateEntryDPSData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('online', onlineOfflineCallback);
    return () => {
      window.removeEventListener('online', onlineOfflineCallback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    checkOfflineFormDataPresent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOfflineDataPresent, isMRATOnline]);

  useEffect(() => {
    if (selectedAssetAliasName) {
      homeDraftData();
      loadAllTagSelectionNonMoData();
      initialiseDataForFormTagSelected();
      loadAllSavedTRFData();
      loadTestMakeModelData();
      if (IsLateEntry) {
        loadAllDpsData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAssetAliasName, IsLateEntry]);
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('notificationAlertsShown');
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const userId = instance.getActiveAccount()?.username;
    if (userId) {
      getAnnouncementStateLog(userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (alertsNotification && alertsNotification.length > 0 && !notificationAlertsShown) {
      setOpenNotificationAlerts(alertsNotification.map((alert, i) => i));
      setNotificationAlertsShown(true);
      localStorage.setItem('notificationAlertsShown', 'true');
    } else if (!alertsNotification || alertsNotification.length === 0) {
      setOpenNotificationAlerts([]);
    }
  }, [alertsNotification, notificationAlertsShown]);
  return (
    <SiteWrapper
      headerText={IsLateEntry ? NONMO_USER_ROLE.LateEntryUser : NONMO_USER_ROLE.User}
      testEquipmentSection={
        (MRAT_USER_ROLE.Technician === userRole || MRAT_USER_ROLE.Engineer === userRole) && selectedAssetName !== ''
          && (isNonMoFeatureEnabled || IsLateEntry)
          ? testEquipmentButtonHandler
          : undefined
      }
      footerButtonHandler={actionButtonHandler}
      FooterButtonVisible={selectedAssetName !== '' && !(isMRATOnline && isOfflineDataPresent)}
      footerEntryButtonVisible={selectedTrfId}
      handleModifyButton={modifyButtonHandler}
      footerButtonText="Create New TRF"
      showInfoIcon
      headerPrintButtonHandler={printButtonHandler}
      widerFooter={widerFooter}
    >
      {toastVisible && alertsNotification && alertsNotification.length > 0 && (
        alertsNotification.map((alert, index) => openNotificationAlerts.includes(index) && (
          <AlertDialog
            key={alert.RowId}
            onDismiss={() => setOpenNotificationAlerts(openNotificationAlerts.filter(i => i !== index))}
            alert={alert.Title}
            alertMessage={alert.AlertMessage}
            backgroundColor={alert.BackgroundColor}
            textColor={alert.TextColor}
          />
        ))
      )}
      <div className="row">
        <div className="col-xs-12">
          <HeaderRegionName>{bpRegionNameAlias}</HeaderRegionName>
          <RadioButtonsGroup
            isOfflineBehaviour={isMRATOnline}
            value={selectedGroupName}
            setValue={saveGroup}
            list={groupNameList}
            label="Group"
            maxWidth="960px"
            margin="0 3rem 0 1rem"
          />
          <RadionAndImageWrapper>
            <RadionButtons>
              <AssetName>
                <RadioButtonsGroup
                  isOfflineBehaviour={isMRATOnline}
                  value={selectedAssetAliasName}
                  setValue={saveAsset}
                  list={assetNameList}
                  label="Asset"
                  margin="0 3.3rem 0 1rem"
                />
              </AssetName>
              <TrfDropdownSelectNonMo />
            </RadionButtons>
            {(selectedAssetImage !== 'null' && showAssetImage) && (
              <HomeImages
                image={selectedAssetImage}
              />
            )}
            <div />
          </RadionAndImageWrapper>
        </div>
      </div>
    </SiteWrapper>
  );
};

const mapStateToProps = ({ Home, MOSelection, DPS, AppData, TestEquipment }) => ({
  regionDetails: Home.regionDetails,
  bpRegionNameAlias: Home.bpRegionNameAlias,
  assetNameList: Home.assetNameList,
  previousScreen: Home.previousScreen,
  workTypeList: Home.workTypeList,
  isMRATOnline: AppData.isMRATOnline,
  barrierTypeList: Home.barrierTypeList,
  selectedAssetName: Home.selectedAssetName,
  selectedGroupName: Home.selectedGroupName,
  selectedWorkType: Home.selectedWorkType,
  selectedBarrierType: Home.selectedBarrierType,
  moDataAll: MOSelection.moDataAll,
  dpsDataAll: DPS.dpsDataAll,
  sortColumn: DPS.sortColumn,
  sortColumnTestEquiment: TestEquipment.sortColumn,
  sortStatusAscOrder: TestEquipment.sortStatusAscOrder,
  sortDeviceTypeAscOrder: TestEquipment.sortDeviceTypeAscOrder,
  dpsSearchString: DPS.dpsSearchString,
  sortFunctionalLocationAscOrder: DPS.sortFunctionalLocationAscOrder,
  sortDisplayStatusAscOrder: DPS.sortDisplayStatusAscOrder,
  isDataLoaded: Home.isDataLoaded,
  isOfflineDataPresent: Home.isOfflineDataPresent,
  selectedAssetAliasName: Home.selectedAssetAliasName,
  searchStringForTestEq: TestEquipment.searchStringForTestEq,
  userRole: Home.userRole,
  alertsNotification: Home.alertsNotification,
  toastVisible: Home.toastVisible,
  IsLateEntry: Home.IsLateEntry
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setCurrentAppView: (view) => dispatch(setCurrentView(view)),
  setPreviousAppScreen: (screen) => dispatch(setPreviousScreen(screen)),
  settingSelectedTRF: (selectedTrfId) => dispatch(setSelectedTRF(selectedTrfId)),
  saveGroup: (value) => {
    dispatch(saveGroupName(value));
  },
  saveAsset: (value) => dispatch(saveAssetName(value)),
  getTrfMasterLists: () => dispatch(getTrfMasterLists()),
  loadAllSavedTRFData: () => dispatch(getAllSavedNonMoTRFData()),
  loadTestMakeModelData: () => dispatch(getTestMakeModelData()),
  loadAllTagSelectionNonMoData: () => dispatch(getSelectTagScreenNonMoData()),
  getInfoDocuments: () => dispatch(getAllInfoDocuments()),
  checkOfflineFormDataPresent: () => dispatch(checkOfflineDataPresent()),
  searchTestEquipmentRecords: (searchVal) => dispatch(searchTestEquipment(searchVal)),
  setSortedTestEquipmentView: (columnName, sortOrder) => dispatch(sortTestEquipment(columnName, sortOrder)),
  clearTestPointValue: () => dispatch(resetTestPointVal()),
  resetSRAData: () => dispatch(clearSRAData()),
  initialiseDataForFormTagSelected: (selectedTag) => dispatch(setDataForFormTagSelected(selectedTag)),
  homeDraftData: () => dispatch(sendOfflineData()),
  resetFormDataValues: () => dispatch(resetFormData()),
  showNotificationAlert: () => dispatch(fetchAlertNotification()),
  loadAllDpsData: () => dispatch(getAllDPSData()),
  getAnnouncementStateLog: (userId) => dispatch(getAnnouncementState(userId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);

HomePage.propTypes = {
  alertsNotification: PropTypes.array,
  assetNameList: PropTypes.array,
  bpRegionNameAlias: PropTypes.string,
  checkOfflineFormDataPresent: PropTypes.func,
  clearTestPointValue: PropTypes.func,
  dispatch: PropTypes.func,
  getAnnouncementStateLog: PropTypes.func,
  getInfoDocuments: PropTypes.func,
  getTrfMasterLists: PropTypes.func,
  homeDraftData: PropTypes.func,
  initialiseDataForFormTagSelected: PropTypes.func,
  isDataLoaded: PropTypes.bool,
  IsLateEntry: PropTypes.bool,
  isMRATOnline: PropTypes.bool,
  isOfflineDataPresent: PropTypes.bool,
  loadAllDpsData: PropTypes.func,
  loadAllSavedTRFData: PropTypes.func,
  loadAllTagSelectionNonMoData: PropTypes.func,
  loadTestMakeModelData: PropTypes.func,
  regionDetails: PropTypes.array,
  resetFormDataValues: PropTypes.func,
  resetSRAData: PropTypes.func,
  saveAsset: PropTypes.func,
  saveGroup: PropTypes.func,
  searchStringForTestEq: PropTypes.string,
  searchTestEquipmentRecords: PropTypes.func,
  selectedAssetAliasName: PropTypes.string,
  selectedAssetName: PropTypes.string,
  selectedGroupName: PropTypes.string,
  setCurrentAppView: PropTypes.func,
  setPreviousAppScreen: PropTypes.func,
  setSortedTestEquipmentView: PropTypes.func,
  settingSelectedTRF: PropTypes.func,
  showNotificationAlert: PropTypes.func,
  sortColumnTestEquiment: PropTypes.string,
  sortDeviceTypeAscOrder: PropTypes.bool,
  sortStatusAscOrder: PropTypes.bool,
  toastVisible: PropTypes.bool,
  userRole: PropTypes.string
};
